'use strict';

// Constructor
var MainNavigation = function () {
//    $(".nano").nanoScroller();

    $('.menu-trigger, .start-exploring-report').click(function ($event) {
        $event.preventDefault();
        $('.main-navigation .level1').addClass('active');
        $('.main-navigation-overlay').addClass('active');
        $(".nano").nanoScroller();
        $('body').addClass('locked');
    });

    $('.close-menu, .main-navigation-overlay').click(function () {
        $('.main-navigation .level1').removeClass('active');
        $('.main-navigation .level2').removeClass('active');
        $('.main-navigation .level3').removeClass('active');
        $('.main-navigation .parent').removeClass('active');
        $('.main-navigation-overlay').removeClass('active');
        $('body').removeClass('locked');
    });

    $('body').on('click', '.close-menu-3', function () {
        $('.main-navigation .level3').removeClass('active');
    });

    $('body').on('click', '.close-menu-2', function () {
        $('.main-navigation .level2').removeClass('active');
    });

    $('body').on('click', '.main-navigation .parent', function ($event) {
        $event.preventDefault();




        // If it was coming from level 1 then close the sub links
        if ($(this).closest('.level').hasClass('level1')) {
            $('.main-navigation .level2').removeClass('active');
            $('.main-navigation .level3').removeClass('active');

            // Remove the active class from the level 1 links
            $('.main-navigation .level1 .parent').removeClass('active');
        }

        // If it was coming from level 2 then close the sub links
        if ($(this).closest('.level').hasClass('level2')) {
            // Remove the active class from the level 1 links
            $('.main-navigation .level2 .parent').removeClass('active');
        }

        // Add active class to current level 1 link
        $(this).addClass('active');


        // Computes the nanoscroller height
        var $height_substractor = window.innerWidth > 1600 ? 140 : 90;

        // Activate the sub menu and add the content
        if ($(this).siblings('.sub-menu').hasClass('sub-menu-2')) {
            if ($(this).siblings('.sub-menu').html().length > 0) {
                $('.main-navigation .level2').html($(this).siblings('.sub-menu').html()).addClass('active');
            } else {
//                $('.main-navigation .level2').html('<h3>No Sub items</h3><button class="close-menu-3 close-menu-back"><i class="icon-arrow-left1"></i><span>back</span></button>').addClass('active');
            }

            var $level2_height = $('.main-navigation .level2.active').height() - $('.main-navigation .level2.active h3').height() - $('.main-navigation .level2.active button').height() - $('.main-navigation .level2.active .overview-title').height() - $height_substractor;
            $(".main-navigation .level2 .nano").height($level2_height);
            $(".main-navigation .level2 .nano").nanoScroller();

        } else {
            if ($(this).siblings('.sub-menu').html().length > 0) {
                $('.main-navigation .level3').html($(this).siblings('.sub-menu').html()).addClass('active');
            } else {
//                $('.main-navigation .level3').html('<h3>No Sub items</h3><button class="close-menu-3 close-menu-back"><i class="icon-arrow-left1"></i><span>back</span></button>').addClass('active');
            }
            setTimeout(function () {
                var $level3_height = $('.main-navigation .level2.active').height() - $('.main-navigation .level2.active h3').height() - $('.main-navigation .level2.active button').height() - $('.main-navigation .level2.active .overview-title').height() - $height_substractor;
                $(".main-navigation .level3 .nano").height($level3_height);
                $(".main-navigation .level3 .nano").nanoScroller();
            }, 400);
        }

    });

};

module.exports = MainNavigation;
